export const validateFloat = (value) => {
  const float = /^\s*(\+|-)?((\d+(\.\d+)?)|(\.\d+))\s*$/
  return float.test(String(value))
}